import React, { useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { 
    Button,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Label,
    Input,
    InputGroup, 
    InputGroupText,
    Row
} from "reactstrap";

import { Eye, EyeSlash } from "react-bootstrap-icons";

// import api from "../../../api/api";
// import AUTH from "../services/authentication";
// import useGoTo from "../../../components/hooks/useGoTo";
// import useToast from "../../../components/hooks/useToast";
// import { useUserInfosContext } from "../../account/components/contexts/UserInfosProvider";
// import { formatPhoneNumber } from "../../../helpers/AssetHelpers";
// import { useLoadingSpinnerContext } from "../../../components/contexts/LoadingSpinnerProvider";
// import { useAlertContext } from "../components/contexts/AlertProvider";
// import { useDataContext } from "../../../components/contexts/DataProvider";

import './SignInForm.css';
import api from "../../../services/api";
// import AUTH from "../services/authentication";
import useGoTo from "../../../components/global-components/hooks/useGoTo";
import { formatPhoneNumber } from "../../../utils/AssetHelpers";
import { useLoaderSpinnerContext } from "../../../components/global-components/providers/LoaderSpinnerProvider";
import { useAlertContext } from "../components/contexts/AlertProvider";
import { useDataContext } from "../../../data/providers/DataProvider";
import AUTH from "../../../services/authentication";

/**
 * 
 * @returns 
 */
const SignInForm = () => {
    /**
     * 
     */
    const [password, setPassword] = useState('');

    /**
     * 
     */
    const [displayPassword, setDisplayPassword] = useState(false);

    /**
     * The dash of 8 is put to avoid collusion with data imported from the context.
     */
    const [phoneNumber, setPhoneNumber] = useState('');
 
    /**
     * 
     */
    const [isTouchedForPhoneNumber, setIsTouchedForPhoneNumber] = useState(false);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);

    const [isTouchedForPassword, setIsTouchedForPassword] = useState(false);
    const [isValidPassword, setIsValidPassword] = useState(false);

    /**
     * 
     * @param number 
     */
    const validatePhoneNumber = (_phoneNumber) => {
        setPhoneNumber(formatPhoneNumber(_phoneNumber));
        setIsValidPhoneNumber(_phoneNumber.length > 0 &&
            _phoneNumber.match(/(^3[3]|^7[5-80])[ ]?[0-9]{3}([ ]?[0-9]{2}){2}$/) !== null);
    };

    /**
     * 
     * @param _password 
     */
    const validatePassword = (_password) => {
        setPassword(_password);
        setIsValidPassword(_password.length > 0);
    };

    /**
     * 
     */
    const { setShow:setShowSpinner } = useLoaderSpinnerContext();

    /**
     * 
     */
    const goTo = useGoTo();

    /**
     * 
     */
    // const showToast = useToast();

    /**
     * 
     */
    // const {
    //     setUserId,
    //     setUserFirstName,
    //     setUserLastName,
    //     setUserGender,
    //     setUserPhoneNumber,
    //     setUserEmailAddress,
    //     setUserRole,
    //     setUserAvatar,
    //     setUserActive,
    //     setUserLogged,
    //     setUserSessionCount,
    //     setUserCreatedAt
    // } = useUserInfosContext();

    /**
     * 
     */
    const {
        setShowAlert,
        setText: setAlertText,
        setColor: setAlertColor
    } = useAlertContext();

    /**
     * 
     */
    const {
        fetchData
    } = useDataContext();

    /**
     * 
     */
    useLayoutEffect(() => {
        setTimeout(() => {
            setShowSpinner(false);
        }, 600);
    }, []);

    /**
     * 
     * @returns 
     */
    const isValidCredentials = () => {
        return (
            isValidPhoneNumber &&
            isValidPassword
        );
    };

    /**
     * 
     * @returns 
     */
    const validateCredentials = () => {
        if(!isValidCredentials()){
            setIsTouchedForPhoneNumber(!isValidPhoneNumber);
            setIsTouchedForPassword(!isValidPassword);
            return false;
        }
        return true;
    };

    /**
     * 
     */
    const logUser = () => {

        if(!validateCredentials()) {
            // showToast('Veuillez remplir tous les champs !', 'warning', { autoClose: 2000 });
            return;
        }
        setShowSpinner(true);

        /**
         * 
         */
        AUTH.login(phoneNumber, password).then((res) => {

            if(res.status === 200 && res.data){
                // showToast(res.data.message, 'success', { autoClose: 2000 });

                api.get('/user', {
                    headers : {
                        Authorization : `Bearer ${res.data.token}`,
                    }
                }).then(response => {
                    // setUserId(response.data.id);
                    // setUserFirstName(response.data.first_name);
                    // setUserLastName(response.data.last_name);
                    // setUserGender(response.data.gender);
                    // setUserPhoneNumber(response.data.phone_number);
                    // setUserEmailAddress(response.data.email);
                    // setUserRole(response.data.role);
                    // setUserAvatar(response.data.avatar);
                    // setUserActive(response.data.active);
                    // setUserLogged(true);
                    // setUserSessionCount(response.data.session_count);
                    // setUserCreatedAt(response.data.created_at);

                    const adminInfos = JSON.stringify({
                        user_id: response.data.id,
                        first_name: response.data.first_name,
                        last_name: response.data.last_name,
                        gender: response.data.gender,
                        phone_number: response.data.phone_number,
                        email_address: response.data.email,
                        role: response.data.role,
                        avatar: response.data.avatar,
                        active: response.data.active,
                        logged: true,
                        session_count: response.data.session_count,
                        created_at: response.data.created_at
                    });
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem(res.data.token, adminInfos);
                    fetchData();
                    setTimeout(() => {
                        goTo('/accueil')
                        setShowSpinner(false)
                    }, 2000);
                });
            }
            else{
                setShowSpinner(false);
                // showToast(res.data.message ? res.data.message : "Une erreur est survenue ! Veuillez réessayer ou contacter l'administrateur.", 'error');
                setShowAlert(true);
                setAlertColor('danger');
                setAlertText(res.data.message ? res.data.message : "Une erreur est survenue ! Veuillez réessayer ou contacter l'administrateur.");
                console.log(res);
            }
        })
        .catch((error) => {
            setShowSpinner(false);
            // showToast(error.response.data.message ? error.response.data.message : "Une erreur est survenue ! Veuillez réessayer ou contacter l'administrateur.", 'error');
            setShowAlert(true);
            setAlertColor('danger');
            setAlertText(error.response.data.message ? error.response.data.message : "Une erreur est survenue ! Veuillez réessayer ou contacter l'administrateur.");
            console.log(error);
        });
    };
    // Notification.requestPermission().then((permission) => {
    //     if (permission === 'granted') {
    //       console.log('Notification permission granted.');}})

    // const messaging = getMessaging();

    // getToken(messaging, { vapidKey: 'BGVqEG3t8h_47kPXhcDaxZPMQiDo3mFuMEzyIB8YFAan6UKrRUb4mlqCE9y1sFMuDNAvGN2Dog7IZxg6OiKtEsU' }).then((currentToken) => {
    //     if (currentToken) {
    //         // Send the token to your server and update the UI if necessary
    //         // ...
    //         console.log(currentToken);
    //     } else {
    //         // Show permission request UI
    //         console.log('No registration token available. Request permission to generate one.');
    //         // ...
    //     }
    // }).catch((err) => {
    //     console.log('An error occurred while retrieving token. ', err);
    //     // ...
    // });

    /**
     * 
     */
    const passwordFormGroupWrapper = useRef(null);

    /**
     * 
     */
    return (
        <Form
            id="signinForm"
            className="form w-100"
        >
            <Row className='gx-4 align-items-center'>
                <Col xs={12}>
                    <div className={`form-group-wrapper mb-1 ${!isValidPhoneNumber && isTouchedForPhoneNumber ? 'is-invalid' : ''}`}>
                        <FormGroup
                            floating={true}
                            className='form-group mb-0'
                        >
                            <Input
                                type='tel'
                                name='phone_number'
                                id='phoneNumberInput'
                                placeholder='Numéro de téléphone'
                                value={phoneNumber}
                                autoComplete='tel'
                                onInput={(e) => validatePhoneNumber(e.currentTarget.value)}
                                onBlur={() => setIsTouchedForPhoneNumber(true)}
                                invalid={!isValidPhoneNumber && isTouchedForPhoneNumber}
                                valid={false}
                            />
                            <Label for='phoneNumberInput'>Numéro de téléphone</Label>
                        </FormGroup>
                        <FormFeedback invalid='true'>{(!phoneNumber.length) ? 'Veuillez renseigner le numéro de téléphone' : 'Numéro de téléphone invalide'}</FormFeedback>
                    </div>
                </Col>
                <Col xs={12}>
                    <div
                        ref={passwordFormGroupWrapper}
                        className={`form-group-wrapper form-group-password-wrapper--- mb-0 ${!isValidPassword && isTouchedForPassword ? 'is-invalid' : ''}`}
                    >
                        {/* <InputGroup className="input-group-password"> */}
                            <FormGroup
                                floating={true}
                                className='form-group mb-0'
                            >
                                    <Input
                                        type={displayPassword ? "text" : "password"}
                                        name='password'
                                        id='passwordInput'
                                        // className='input-group-password-password-input border-end-0'
                                        placeholder='Mot de passe'
                                        value={password}
                                        onInput={(e) => validatePassword(e.currentTarget.value)}
                                        onBlur={() => {
                                            setIsTouchedForPassword(true);
                                            passwordFormGroupWrapper.current?.classList.remove('focus');
                                        }}
                                        invalid={!isValidPassword && isTouchedForPassword}
                                        valid={false}
                                        onFocus={() => {
                                            passwordFormGroupWrapper.current?.classList.add('focus');
                                        }}
                                    />
                                <Label for='passwordInput'>Mot de passe</Label>
                            </FormGroup>
                            {/* <InputGroupText
                                id="singinPasswordVisibilityTogglerWrapper"
                                className="password-visibility-toggler-wrapper bg-transparent border-start-0 m-0 p-0"
                            >
                                <Button
                                    tag='button'
                                    type='button'
                                    size='sm'
                                    color='transparent'
                                    className="password-visibility-toggler"
                                    onClick={() => setDisplayPassword(!displayPassword)}
                                >
                                {
                                    displayPassword ? <Eye size={20} /> : <EyeSlash size={20} />
                                }
                                </Button>
                            </InputGroupText> */}
                        {/* </InputGroup> */}
                        <FormFeedback invalid='true'>Veuillez renseigner le mot de passe</FormFeedback>
                    </div>
                </Col>
            </Row>
            <Row className='gx-4 align-items-center'>
                <Col xs={12}>
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-end gap-3 fs-base mb-8">
                        <Link
                            to='/reinitialisation-du-mot-de-passe'
                            id="passwordResetLink"
                            // className='link-secondary link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover'
                        >
                            <span>Mot de passe oublié ?</span>
                        </Link>
                    </div>
                </Col>
                <Col xs={12}>
                    <div className="d-grid mb-1">
                        <Button
                            tag='button'
                            type='button'
                            color='success'
                            onClick={logUser}
                        >
                            <span>Connexion</span>
                        </Button>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};

export default SignInForm;
